import { FC } from "react";
import { useOrgId } from "@src/common/reliablePartnerApi";
import { useAppSelector } from "@src/reduxStore";

export interface LinkToCompanyContactDetailsProps {
  orgId?: string;
}

const LinkToCompanyContactDetails: FC<LinkToCompanyContactDetailsProps> = ({
  children,
  orgId,
}) => {
  const config = useAppSelector(state => state.common.config);
  const currentOrgId = useOrgId();
  const urlOrgId = orgId || currentOrgId;

  return (
    <a
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      href={`${config?.companiesUrl}/#/${urlOrgId}/organization/contactdetails`}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToCompanyContactDetails;
